import { Card, Typography, Descriptions, Tag, Spin, theme, Space } from 'antd';
import { useCurrentUser } from '../auth/useCurrentUser';
import { useT } from '../locales';
import { EmptyState } from '../components/EmptyState';
import { StatusTag } from '../components/StatusTag';

const { Title } = Typography;

export function ProfilePage() {
  const t = useT();
  const { user, isLoading, error } = useCurrentUser();
  const { token } = theme.useToken();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error || !user) {
    return <EmptyState title={t('error.generic')} />;
  }

  return (
    <Card
      style={{
        borderRadius: 12,
        border: `1px solid ${token.colorBorderSecondary}`,
      }}
    >
      <Title
        level={3}
        style={{
          margin: 0,
          fontSize: 22,
          fontWeight: 600,
          letterSpacing: '-0.015em',
        }}
      >
        {t('profile.title')}
      </Title>
      <Descriptions
        column={{ xs: 1, sm: 2 }}
        style={{ marginTop: 20 }}
        labelStyle={{
          color: token.colorTextSecondary,
          fontWeight: 500,
          width: 180,
          paddingTop: 14,
          paddingBottom: 14,
        }}
        contentStyle={{ paddingTop: 14, paddingBottom: 14 }}
      >
        <Descriptions.Item label={t('profile.email')}>{user.email}</Descriptions.Item>
        <Descriptions.Item label={t('profile.name')}>
          {[user.firstName, user.lastName].filter(Boolean).join(' ') || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('profile.roles')}>
          {user.roles.map((r) => (
            <StatusTag key={r.id} tone="info" style={{ marginInlineEnd: 6 }}>
              {r.name}
            </StatusTag>
          ))}
          {user.roles.length === 0 && '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('profile.permissions')}>
          <Space wrap size={[6, 6]}>
            {user.roles
              .flatMap((r) => r.permissions)
              .map((p) => (
                <Tag key={p.id}>{p.name}</Tag>
              ))}
          </Space>
          {user.roles.flatMap((r) => r.permissions).length === 0 && '-'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
